/* ============================================================
   Yiume Reconstructed — product.js

   Variantkiezer en afbeeldingsgalerij op de productpagina.
   Laadt alleen op product-templates (zie layout/theme.liquid).

   De volledige productdata staat al als JSON in de pagina, dus
   het wisselen van variant vraagt geen enkele extra request.
   ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('[data-product-root]');
  if (!root) return;

  const T = window.theme || {};
  const $ = (sel, r = document) => r.querySelector(sel);
  const $$ = (sel, r = document) => Array.from(r.querySelectorAll(sel));

  /* ── productdata ── */
  const productId = root.getAttribute('data-product-id');
  const jsonEl = document.getElementById('ProductJson-' + productId);
  let product = null;
  try { product = JSON.parse(jsonEl.textContent); } catch { return; }
  if (!product || !product.variants) return;

  function formatMoney(cents) {
    const fmt = T.moneyFormat || '${{amount}}';
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const [int, dec] = amount.split('.');
    const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, grouped + '.' + dec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, grouped)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,
        int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec);
  }

  /* ── 1. Galerij ────────────────────────────────────────── */
  const mainImage = $('[data-gallery-image]');
  const thumbs = $$('[data-gallery-thumb]');

  function showImage(src, alt) {
    if (!mainImage || !src) return;
    mainImage.src = src;
    if (alt) mainImage.alt = alt;
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      showImage(thumb.getAttribute('data-image-src'), thumb.getAttribute('data-image-alt'));
    });
  });

  /** Springt naar de thumbnail die bij een variantafbeelding hoort. */
  function syncGalleryToVariant(variant) {
    const src = variant && variant.featured_image && variant.featured_image.src;
    if (!src) return;
    const base = src.split('?')[0].replace(/^https?:/, '');
    const match = thumbs.find((t) => {
      const ts = (t.getAttribute('data-image-src') || '').split('?')[0].replace(/^https?:/, '');
      return ts === base;
    });
    if (match) match.click();
    else showImage(src, variant.name || product.title);
  }

  /* ── 2. Variantkiezer ──────────────────────────────────── */
  const picker = $('[data-variant-picker]');

  /** Leest de gekozen waarde per optie-positie. */
  function selectedOptions() {
    if (!picker) return [];
    return $$('fieldset.option', picker).map((set) => {
      const checked = $('input:checked', set);
      return checked ? checked.value : null;
    });
  }

  function findVariant(options) {
    return product.variants.find((v) =>
      options.every((val, i) => val == null || v['option' + (i + 1)] === val));
  }

  /**
   * Grijst waarden uit die in combinatie met de huidige keuze niet bestaan.
   * Kijkt alleen naar de opties links van de betreffende positie, zoals
   * Shopify's eigen gedrag: je kiest van links naar rechts.
   */
  function updateAvailability(options) {
    if (!picker) return;
    $$('fieldset.option', picker).forEach((set, index) => {
      $$('input', set).forEach((input) => {
        const probe = options.slice();
        probe[index] = input.value;
        const exists = product.variants.some((v) =>
          probe.every((val, i) => (i > index && false) || val == null || v['option' + (i + 1)] === val));
        const available = product.variants.some((v) =>
          probe.every((val, i) => val == null || v['option' + (i + 1)] === val) && v.available);
        const label = set.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('option__value--unavailable', !exists || !available);
      });
    });
  }

  function updateUI(variant) {
    const addBtn = $('[data-add-to-cart]');
    const addText = $('[data-add-to-cart-text]');
    const idInput = $('[data-variant-id]');
    const priceWrap = $('.product__price');
    const skuEl = $('[data-variant-sku]');
    const availEl = $('[data-availability]');

    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = T.strings.unavailable || 'Unavailable';
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (addBtn) addBtn.disabled = !variant.available;
    if (addText) {
      addText.textContent = variant.available
        ? (T.strings.addToCart || 'Add to cart')
        : (T.strings.soldOut || 'Sold out');
    }

    if (priceWrap) {
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceWrap.classList.toggle('price--on-sale', !!onSale);
      const current = $('.price__current', priceWrap);
      if (current) current.textContent = formatMoney(variant.price);
      let compare = $('.price__compare', priceWrap);
      if (onSale) {
        if (!compare) {
          compare = document.createElement('s');
          compare.className = 'price__compare';
          current && current.after(compare);
        }
        compare.textContent = formatMoney(variant.compare_at_price);
      } else if (compare) compare.remove();
    }

    if (skuEl) skuEl.textContent = variant.sku || '';

    if (availEl) {
      availEl.textContent = variant.available
        ? (T.strings.inStock || 'In stock')
        : (T.strings.outOfStock || 'Out of stock');
      availEl.classList.toggle('product__availability--out', !variant.available);
    }

    /* Labels bij elke optie bijwerken. */
    if (picker) {
      $$('fieldset.option', picker).forEach((set, i) => {
        const out = $('[data-option-selected]', set);
        if (out) out.textContent = variant['option' + (i + 1)] || '';
      });
    }

    syncGalleryToVariant(variant);

    /* URL bijwerken zodat delen en terugnavigeren de variant behoudt. */
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  /* ── 3. Vaste koopbalk ─────────────────────────────────── */
  const sticky = document.querySelector('[data-sticky-atc]');
  const buyBlock = document.querySelector('[data-add-to-cart]');
  if (sticky && buyBlock && 'IntersectionObserver' in window) {
    const anchor = buyBlock.closest('.product__buy') || buyBlock;

    /* Staat de balk op mobiel altijd aan, dan mag de observer hem daar niet
       alsnog verbergen. De zichtbaarheid zit in dat geval in CSS; hier alleen
       aria-hidden goed houden, anders meldt een schermlezer een koopknop die
       er wel degelijk staat als verborgen. */
    const altijdMobiel = sticky.hasAttribute('data-always-mobile');
    const isMobiel = () => window.matchMedia('(max-width: 991px)').matches;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const gescrold = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        const show = (altijdMobiel && isMobiel()) || gescrold;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      });
    }, { threshold: 0 });
    io.observe(anchor);

    /* Beginstand goed zetten: de observer vuurt pas bij de eerste
       doorsnijding, en tot die tijd zou de balk op mobiel als verborgen in
       de toegankelijkheidsboom staan. */
    sticky.setAttribute('aria-hidden', String(!(altijdMobiel && isMobiel())));

    /* De variant in de balk meelaten lopen met de kiezer. */
    document.addEventListener('change', () => {
      const src = document.querySelector('form#ProductForm [data-variant-id]');
      const dst = sticky.querySelector('[data-variant-id]');
      if (src && dst) dst.value = src.value;
    });
  }

  /* ── 4. Recent bekeken ─────────────────────────────────── */
  const RECENT_KEY = 'yiume:recently-viewed';
  const readRecent = () => {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch { return []; }
  };

  /* Huidig product vooraan zetten, maximaal 20 onthouden. */
  try {
    const list = readRecent().filter((h) => h !== product.handle);
    list.unshift(product.handle);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 20)));
  } catch { /* private mode: dan simpelweg geen geschiedenis */ }

  const recentRoot = document.querySelector('[data-recently-viewed]');
  if (recentRoot) {
    const grid = recentRoot.querySelector('[data-recently-viewed-grid]');
    const limit = Number(recentRoot.getAttribute('data-limit')) || 4;
    const exclude = recentRoot.getAttribute('data-exclude');
    const handles = readRecent().filter((h) => h !== exclude).slice(0, limit);

    if (handles.length && grid) {
      /* Elke kaart komt uit de storefront zelf, zodat hij identiek is aan
         de kaarten elders op de site. */
      Promise.all(handles.map((h) =>
        fetch('/products/' + encodeURIComponent(h) + '?view=card')
          .then((r) => (r.ok ? r.text() : null))
          .catch(() => null)))
        .then((pages) => {
          const html = pages.filter(Boolean).map((p) => {
            const doc = new DOMParser().parseFromString(p, 'text/html');
            const card = doc.querySelector('.card');
            return card ? card.outerHTML : '';
          }).filter(Boolean).join('');
          if (html) { grid.innerHTML = html; recentRoot.classList.remove('hidden'); }
        });
    }
  }

  if (picker) {
    picker.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option-value]')) return;
      const options = selectedOptions();
      updateAvailability(options);
      updateUI(findVariant(options));
    });

    /* Beginstaat: variant uit de URL, anders de eerste beschikbare. */
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) {
      const v = product.variants.find((x) => String(x.id) === urlVariant);
      if (v) {
        $$('fieldset.option', picker).forEach((set, i) => {
          const want = v['option' + (i + 1)];
          const input = $$('input', set).find((x) => x.value === want);
          if (input) input.checked = true;
        });
      }
    }
    const initial = selectedOptions();
    updateAvailability(initial);
    updateUI(findVariant(initial));
  }
})();
